// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
.notification {
  position: sticky;
  bottom: 1.5rem;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column-reverse;
  gap: 0.75rem;
  z-index: 1000;
  height: 0;
  pointer-events: none;
}
.notification .notificationItem {
  position: relative;
  pointer-events: auto;
  margin: 0 auto;
  width: 92%;
  max-width: 340px;
  padding: 1rem 1.25rem;
  border-radius: 16px;
  font-size: 0.95rem;
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  animation: slideUpIn 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}
.notification .notificationItem .close {
  position: absolute;
  right: 0.65rem;
  top: 0.6rem;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.notification .notificationItem .close .close-icon {
  position: absolute;
  font-size: 1.05rem;
  line-height: 1;
  opacity: 0.75;
  transition: opacity 0.2s;
}
.notification .notificationItem .close:hover .close-icon {
  opacity: 1;
}
.notification .notificationItem .close .ring {
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(-90deg);
  color: inherit;
}
.notification .notificationItem .close .ring-track {
  stroke: currentColor;
  opacity: 0.2;
}
.notification .notificationItem .close .ring-progress {
  stroke: currentColor;
  transform-origin: center;
  animation-name: notif-countdown;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
.notification .notificationItem .close .ring--paused .ring-progress {
  animation-play-state: paused;
}
.notification .notificationItem span {
  display: block;
  line-height: 1.4;
}
.notification .notificationItem .title {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 0.2rem;
  letter-spacing: -0.3px;
}
.notification .notificationItem.success {
  background-color: rgba(76, 175, 80, 0.92);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.notification .notificationItem.error {
  background-color: rgba(235, 64, 52, 0.92);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.notification .notificationItem.warning {
  background-color: rgba(255, 193, 7, 0.95);
  color: #333;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

@keyframes slideUpIn {
  from {
    transform: translateY(20px) scale(0.95);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
@keyframes notif-countdown {
  from {
    stroke-dashoffset: 0;
  }
  to {
    stroke-dashoffset: 56.5;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/Theme/variables/_fonts.scss","webpack://./src/components/Notification/Notification.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACCF;ADEA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACAF;ADGA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACDF;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACFF;ADKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACHF;ADMA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACJF;ADOA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACLF;ADQA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACNF;ADSA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACPF;ADUA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACRF;ADWA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACTF;ADYA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACVF;AArEA;EACE,gBAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,oBAAA;AAuEF;AArEE;EACE,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;UAAA,2BAAA;EACA,2CAAA;EACA,2EAAA;AAuEJ;AArEI;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAuEN;AArEM;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,wBAAA;AAuER;AApEM;EACE,UAAA;AAsER;AAnEM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,cAAA;AAqER;AAnEQ;EACE,oBAAA;EACA,YAAA;AAqEV;AAlEQ;EACE,oBAAA;EACA,wBAAA;EACA,+BAAA;EACA,iCAAA;EACA,6BAAA;AAoEV;AAjEQ;EACE,4BAAA;AAmEV;AA9DI;EACE,cAAA;EACA,gBAAA;AAgEN;AA7DI;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AA+DN;AA5DI;EACE,yCAAA;EACA,cC1FE;ED2FF,0CAAA;AA8DN;AA3DI;EACE,yCAAA;EACA,cChGE;EDiGF,0CAAA;AA6DN;AA1DI;EACE,yCAAA;EACA,WAAA;EACA,qCAAA;AA4DN;;AAvDA;EACE;IACE,uCAAA;IACA,UAAA;EA0DF;EAxDA;IACE,iCAAA;IACA,UAAA;EA0DF;AACF;AAvDA;EACE;IACE,oBAAA;EAyDF;EAvDA;IACE,uBAAA;EAyDF;AACF","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-ThinItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-LightItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-MediumItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BlackItalic.ttf') format('truetype');\n}\n","@import '../../assets/Theme';\n\n.notification {\n  position: sticky;\n  bottom: 1.5rem;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 0.75rem;\n  z-index: 1000;\n  height: 0;\n  pointer-events: none;\n\n  .notificationItem {\n    position: relative;\n    pointer-events: auto;\n    margin: 0 auto;\n    width: 92%;\n    max-width: 340px;\n    padding: 1rem 1.25rem;\n    border-radius: 16px;\n    font-size: 0.95rem;\n    backdrop-filter: blur(12px);\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n    animation: slideUpIn 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n\n    .close {\n      position: absolute;\n      right: 0.65rem;\n      top: 0.6rem;\n      width: 28px;\n      height: 28px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n\n      .close-icon {\n        position: absolute;\n        font-size: 1.05rem;\n        line-height: 1;\n        opacity: 0.75;\n        transition: opacity 0.2s;\n      }\n\n      &:hover .close-icon {\n        opacity: 1;\n      }\n\n      .ring {\n        position: absolute;\n        top: 0;\n        left: 0;\n        transform: rotate(-90deg);\n        color: inherit;\n\n        &-track {\n          stroke: currentColor;\n          opacity: 0.2;\n        }\n\n        &-progress {\n          stroke: currentColor;\n          transform-origin: center;\n          animation-name: notif-countdown;\n          animation-timing-function: linear;\n          animation-fill-mode: forwards;\n        }\n\n        &--paused .ring-progress {\n          animation-play-state: paused;\n        }\n      }\n    }\n\n    span {\n      display: block;\n      line-height: 1.4;\n    }\n\n    .title {\n      font-size: 1.1rem;\n      font-weight: 700;\n      margin-bottom: 0.2rem;\n      letter-spacing: -0.3px;\n    }\n\n    &.success {\n      background-color: rgba(76, 175, 80, 0.92);\n      color: $white;\n      border: 1px solid rgba(255, 255, 255, 0.2);\n    }\n\n    &.error {\n      background-color: rgba(235, 64, 52, 0.92);\n      color: $white;\n      border: 1px solid rgba(255, 255, 255, 0.2);\n    }\n\n    &.warning {\n      background-color: rgba(255, 193, 7, 0.95);\n      color: #333;\n      border: 1px solid rgba(0, 0, 0, 0.05);\n    }\n  }\n}\n\n@keyframes slideUpIn {\n  from {\n    transform: translateY(20px) scale(0.95);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes notif-countdown {\n  from {\n    stroke-dashoffset: 0;\n  }\n  to {\n    stroke-dashoffset: 56.5;\n  }\n}","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
